export default "__VITE_ASSET__DgnPyUmg__"